export const ForgotPasswordLink =
    "https://www.nucleusfinancial.net/nucleus/ria/registration/forgotpassword.seam";
export const RegisterLink = "https://www.nucleusfinancial.net/nucleus/ria/register";
export const PlatformLink = "https://www.nucleusfinancial.net";
export const TermsAndConditionsLink = "https://nucleusfinancial.com/terms-and-conditions/";
export const PrivacyPolicyLink = "https://nucleusfinancial.com/privacy-policy/";
export const ClientSupportLink =
    "https://www.nucleusfinancial.com/client-home/nucleus-go-client-support";
